function findFB(e) {
    var FBURL;
    var FB = e.target;
    var FBUData = FB.closest('[data-fb]');
    if (FB && FBUData) {
        e.preventDefault();
        FBURL = FBUData.dataset.fb
        var modal = document.querySelector('.FB-termButton');
        if (modal) {
            modal.classList.remove('hide')
            var checkbox = modal.querySelector('[type=checkbox]')
            if (checkbox) {
                checkbox.checked = false;
                checkbox.addEventListener('click', function (e) {
                    if (checkbox.checked) {
                        window.parent.location.href = FBURL
                    } else {
                        e.preventDefault();
                        e.stopImmediatePropagation();
                    }
                })
            }

            modal.querySelector('.cancel').addEventListener('click', function () {
                modal.classList.add('hide')
            })
        }

    }

}

window.addEventListener('click', findFB)